import React from "react";
import { Button, Stack, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const ActionButtons = ({ loading, scheduleId, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2} justifyContent="center">
      <Button
        variant="outlined"
        onClick={onCancel}
        sx={{
          textTransform: "none",
          width: "122px",
          color: "#1F242E",
          fontWeight: 600,
          fontSize: "20px",
        }}
        disabled={loading}
      >
        <Typography component="span">{t("Cancel")}</Typography>
      </Button>
      <Button
        type="submit"
        disabled={loading}
        sx={{
          width: "122px",
          color: "#1F242E",
          fontWeight: 600,
          fontSize: "20px",
          background: "#F9E719",
          "&:hover": {
            backgroundColor: "#F9E719",
          },
          textTransform: "none",
        }}
      >
        <Typography component="span">
          {loading ? (
            <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
          ) : null}
          {scheduleId ? t("Update") : t("Save")}
        </Typography>
      </Button>
    </Stack>
  );
};

export default ActionButtons;